<template>
  <div id="box">
    <el-card class="box-card">
</el-card>
    <el-collapse v-model="activeName">
  <el-collapse-item title="METAL CATEGORY" name="1">
    <el-row :gutter="20">
 <el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Co.csv">Co</a></div><div class="num">(1328)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Ta.csv">Ta</a></div><div class="num">(4)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Os.csv">Os</a></div><div class="num">(7)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Pt.csv">Pt</a></div><div class="num">(53)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Mg.csv">Mg</a></div><div class="num">(35374)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Mn.csv">Mn</a></div><div class="num">(7604)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/U.csv">U</a></div><div class="num">(11)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Sn.csv">Sn</a></div><div class="num">(3)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Pb.csv">Pb</a></div><div class="num">(30)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Al.csv">Al</a></div><div class="num">(12)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Na.csv">Na</a></div><div class="num">(2447)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Pr.csv">Pr</a></div><div class="num">(15)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Y.csv">Y</a></div><div class="num">(30)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Cd.csv">Cd</a></div><div class="num">(356)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Ir.csv">Ir</a></div><div class="num">(5)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Ho.csv">Ho</a></div><div class="num">(5)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Cs.csv">Cs</a></div><div class="num">(31)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/La.csv">La</a></div><div class="num">(6)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Ga.csv">Ga</a></div><div class="num">(4)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Ni.csv">Ni</a></div><div class="num">(1277)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Ag.csv">Ag</a></div><div class="num">(15)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Lu.csv">Lu</a></div><div class="num">(7)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Yb.csv">Yb</a></div><div class="num">(7)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Rh.csv">Rh</a></div><div class="num">(1)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Re.csv">Re</a></div><div class="num">(2)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Eu.csv">Eu</a></div><div class="num">(5)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Cr.csv">Cr</a></div><div class="num">(1)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Ca.csv">Ca</a></div><div class="num">(6126)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Cu.csv">Cu</a></div><div class="num">(1789)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Ce.csv">Ce</a></div><div class="num">(1)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Sm.csv">Sm</a></div><div class="num">(15)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Sb.csv">Sb</a></div><div class="num">(2)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Tl.csv">Tl</a></div><div class="num">(7)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/K.csv">K</a></div><div class="num">(2481)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Ba.csv">Ba</a></div><div class="num">(21)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Rb.csv">Rb</a></div><div class="num">(10)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Tb.csv">Tb</a></div><div class="num">(5)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Mo.csv">Mo</a></div><div class="num">(242)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/W.csv">W</a></div><div class="num">(29)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Fe.csv">Fe</a></div><div class="num">(26792)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Hg.csv">Hg</a></div><div class="num">(265)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Sr.csv">Sr</a></div><div class="num">(32)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Be.csv">Be</a></div><div class="num">(29)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Bi.csv">Bi</a></div><div class="num">(1)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/V.csv">V</a></div><div class="num">(32)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/As.csv">As</a></div><div class="num">(39)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Gd.csv">Gd</a></div><div class="num">(25)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Er.csv">Er</a></div><div class="num">(1)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Zn.csv">Zn</a></div><div class="num">(29424)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Pd.csv">Pd</a></div><div class="num">(3)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Li.csv">Li</a></div><div class="num">(22)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Pa.csv">Pa</a></div><div class="num">(1)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Au.csv">Au</a></div><div class="num">(40)</div></div></el-col>
<el-col :span="2"><div class="card"><div class="font"><a href="@/../static/data/Ru.csv">Ru</a></div><div class="num">(8)</div></div></el-col>

</el-row>
 <h3 class="intro">Right now, what you see is the download page. To see more information, please click 
    <a href="http://183.175.59.23:8003/docs/">API</a>.</h3>
  </el-collapse-item>
  <el-collapse-item title="FILE" name="2">
    <div>
      <h3 style="text-indent:50px;">We give all the PDB and UniProt entries in the database, as well as all the species information included.</h3>
    </div>
    <div class= "file"><a href="@/../static/uniprot.csv" download="uniprot.csv">
<el-button type="info" plain>UniProt</el-button></a>
<a href="@/../static/pdb.csv" download="pdb.csv">
<el-button type="info" plain>PDB</el-button></a>
<a href="@/../static/alphafold.csv" download="alphaflod.csv">
<el-button type="info" plain>AlphaFold</el-button></a>
<a href="@/../static/tax_id.csv" download="tax_id.csv">
<el-button type="info" plain>Species</el-button></a>
</div>
  </el-collapse-item>
   <el-collapse-item title="MUTATIONS" name="3">
    <div>
      <h3 style="text-indent:50px;">Here is a list of potential mutation sites of proteins contained in several species.</h3>
    </div>
    <div class= "file"><a href="@/../static/bovine.csv" download="bovine.csv">
<el-button type="info" plain>Bovine</el-button></a>
<a href="@/../static/dog.csv" download="dog.csv">
<el-button type="info" plain>Dog</el-button></a>
<a href="@/../static/goat.csv" download="goat.csv">
<el-button type="info" plain>Goat</el-button></a>
<a href="@/../static/horse.csv" download="horse.csv">
<el-button type="info" plain>Horse</el-button></a>
<a href="@/../static/mouse.csv" download="mouse.csv">
<el-button type="info" plain>Mouse</el-button></a>
<a href="@/../static/pig.csv" download="pig.csv">
<el-button type="info" plain>Pig</el-button></a>
<a href="@/../static/rat.csv" download="rat.csv">
<el-button type="info" plain>Rat</el-button></a>
<a href="@/../static/sheep.csv" download="sheep.csv">
<el-button type="info" plain>Sheep</el-button></a>
</div>
  </el-collapse-item>
 
</el-collapse>
  </div>
</template>
<style lang="less" scoped>
.intro{
  text-align: center;
  color: #888888;
}


#box{
  padding-top:50px;
  width: 77%;
  margin: auto;
  margin-bottom:40px;
}
 /deep/ .el-collapse-item__header{
   background-color: #e3e5e7;
  color: rgb(153, 102, 51);
  font-size: 20px;
  padding-left:30px;
}

.card{
  display: flex;
  flex-direction:column;
  widows: 100%;
  height: 70px;
  border:1px solid rgb(219, 217, 217);
  margin-top: 20px;
  box-shadow: 2px 2px 5px #888888;
}
.font{
  display: flex;
  flex-direction:row;
   justify-content:center;
  width: 100%;
  height: 40px;
  margin: auto;
  a{
    font-size: 24px;
    text-decoration: none;
    color:#29629b;
  }
}
.num{
  width: 100%;
  height: 30px;
  display: flex;
  flex-direction:row;
   justify-content:center;
       font-weight: bold;
}
.file{
  text-align: center;
}
</style>
<script>
  export default {
    data() {
      return {
        activeName: '1'
      };
    }
  }
</script>